module.exports = __webpack_public_path__ + "static/media/5get.7a7f6aa3.svg";